module.exports = __webpack_public_path__ + "img/productinfo-7.11fcd277.jpg";